/* Load the unchanged Judge.me full widget only as its section approaches. */
if (!customElements.get('ll-lazy-reviews')) {
  customElements.define('ll-lazy-reviews',class extends HTMLElement {
    connectedCallback(){
      if(this.loaded)return;
      this.onReviewJump=event=>{
        if(event.type==='keydown'&&!['Enter',' '].includes(event.key))return;
        if(!event.target.closest('.jdgm-prev-badge,a[href="#judgeme_product_reviews"]'))return;
        if(event.type==='keydown')event.preventDefault();
        this.load();requestAnimationFrame(()=>this.scrollIntoView({behavior:'smooth',block:'start'}));
      };
      document.addEventListener('click',this.onReviewJump,true);
      document.addEventListener('keydown',this.onReviewJump,true);
      if(location.hash==='#judgeme_product_reviews'){this.load();return;}
      if(!('IntersectionObserver'in window)){this.load();return;}
      this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'900px 0px'});
      this.observer.observe(this);
    }
    async load(){
      if(this.loaded)return;
      // Avoid laying out the full app review list during the first product paint.
      const template=this.querySelector('[data-ll-review-template]');
      if(template){this.append(template.content.cloneNode(true));template.remove();}
      const content=this.querySelector('[data-ll-review-content]');if(content)content.hidden=false;
      const widget=this.querySelector('[data-ll-entry-point]');
      if(!widget)return;
      const base=window.jdgm?.CDN_BASE_URL;
      if(!base){this.retry=setTimeout(()=>this.load(),200);return;}
      this.loaded=true;
      const entry=widget.dataset.llEntryPoint,key=widget.dataset.llEntryKey;
      widget.dataset.entryPoint=entry;widget.dataset.entryKey=key;
      // Use the app's own entry and dependency manifest, keeping its UI intact.
      try{
        const response=await fetch(base+'manifest.json');
        if(!response.ok)throw Error('Review stylesheet manifest unavailable');
        const manifest=await response.json(),seen=new Set();
        const styles=[];
        const visit=name=>{if(seen.has(name))return;seen.add(name);const node=manifest[name];if(!node)return;for(const css of node.css||[])styles.push(css);for(const dependency of node.imports||[])visit(dependency);};visit(key);
        await Promise.all([...new Set(styles)].map(css=>new Promise(resolve=>{
          const href=base+css;if(document.querySelector(`link[href="${href}"]`)){resolve();return;}
          const link=document.createElement('link');link.rel='stylesheet';link.href=href;link.onload=link.onerror=resolve;document.head.append(link);
        })));
      }catch(error){console.warn('Limitless reviews: loading the app with its stylesheet fallback.',error);}
      if(!document.querySelector(`script[src="${base+entry}"]`)){
        const script=document.createElement('script');script.type='module';script.src=base+entry;document.head.append(script);
      }
    }
    disconnectedCallback(){this.observer?.disconnect();clearTimeout(this.retry);document.removeEventListener('click',this.onReviewJump,true);document.removeEventListener('keydown',this.onReviewJump,true);}
  });
}
